import React from 'react';
import { isEmpty } from 'lodash';
import { pure } from 'recompose';
import { Button, Col, Row } from 'angieslist-react-components';
import { Showcase } from '../../common/profileService';
import ShowcaseIndexCard from './ShowcaseIndexCard';

type Props = {
  draftShowcases: Showcase[],
  serviceProviderId: string | number,
  archiveShowcase: (showcaseId: number, serviceProviderId: string | number) => void,
  showcasePendingRemoval?: boolean,
  switchTab: (tabName: string) => void,
};

const ShowcaseDraftTab = ({
  draftShowcases, switchTab, archiveShowcase, serviceProviderId, showcasePendingRemoval,
}: Props) => (
  <Row>
    <Choose>
      <When condition={!isEmpty(draftShowcases)}>
        {draftShowcases.map(showcase => (
          <Col lg={4} sm={6} xs={12} key={showcase.showcaseId}>
            <ShowcaseIndexCard
              showcase={showcase}
              serviceProviderId={serviceProviderId}
              archiveShowcase={archiveShowcase}
              isLoading={showcasePendingRemoval === showcase.showcaseId}
              key={`draft-index-card-${showcase.showcaseId}`}
              isDraggable={false}
              labelText="Draft"
            />
          </Col>
                ))}
      </When>
      <Otherwise>
        <div className="showcase-tab-no-showcase-found-text" >
          <i>You do not have any drafted projects.</i>
        </div>
        <div className="text-center">
          <Button
            className="showcase-tab-switch-tab-link"
            id="draft-tab-switch-button"
            onClick={() => switchTab('PublishedTab')}
            bsStyle="link"
            flat
          >
            <strong>View Published Projects</strong>
          </Button>
        </div>
      </Otherwise>
    </Choose>
  </Row>
);

export default pure(ShowcaseDraftTab);



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/ShowcaseDraftTab.js